import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { SPOT_FILL_RATE_CHART_ENDPOINT } from '../transaction-chart-endpoints';

export const SPOT_FILL_RATE_METRIC_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.SPOT_FILL_RATE_METRIC,
    chartType: ChartRendererType.METRIC,
    endpoint: SPOT_FILL_RATE_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.MONTH }]
};
